import { BaseDto } from "../common/baseDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface ProductWorkDto extends BaseDto {

	productWorkNo: string;
	compCd: string;
	compNm: string;
	workDt: string | undefined;
	fromTime: string | undefined;
	toTime: string | undefined;
	orderType: string;
	workplaceCd: string;
	workplaceNm: string;
	jobTeam: string;
	workProcess: string;
	itemCd: string;
	itemNm: string;
	itemSpec: string;
	itemUnit: string;
	orderQty: number;
	workEmp: string;
	workEmpNm: string;
	resultQty: number;
	productOrderNo: string;
	closeTag: string;
	remark: string;


	inserted: boolean;
	isModified: boolean;
}

export const defaultProductWorkDto: ProductWorkDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productWorkNo: '',
	compCd: '',
	compNm: '',
	workDt: formatDate(new Date()),
	fromTime: toLocalDateTime(new Date()),
	toTime: toLocalDateTime(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderQty: 0,
	workEmp: '',
	workEmpNm: '',
	resultQty: 0,
	productOrderNo: '',
	closeTag: "N",
	remark: '',

	inserted: false,
	isModified: false
}










